import { DateInput } from '@payaca/ambrosia';
import { isoDateToLocalDate, localDateToIsoDate } from '@payaca/custom-fields';
import { FC } from 'react';
import { useIsoDateFormatter } from '../dateFormatContext';
import { FieldProps } from './fieldInputTypes';

export const DateFieldInput: FC<FieldProps<'date'>> = (props) => {
  const { value, onChange } = props;
  const formatIsoDate = useIsoDateFormatter();

  return (
    <DateInput
      showDateSelect
      value={value ? isoDateToLocalDate(value) : null}
      valueFormatter={(date) => formatIsoDate(localDateToIsoDate(date))}
      onChange={(date) => onChange(localDateToIsoDate(date))}
    />
  );
};
